(function () {
  'use strict';

  if (!/^ar(?:-|$)/i.test(document.documentElement.lang || '')) return;
  var configNode = document.getElementById('frame-smile-ar-config');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
  if (!config || typeof config.loyaltyPath !== 'string') return;
  var path = config.loyaltyPath.replace(/\/$/, '');
  if (path !== window.location.pathname.replace(/\/$/, '')) return;
  var currency = typeof config.currency === 'string' && /^[A-Z]{3}$/.test(config.currency) ? config.currency : null;
  var waitMilliseconds = 12000;
  var mountObserver;
  var mountTimer;

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function number(value) {
    return typeof value === 'number' && Number.isFinite(value) && value >= 0;
  }

  function format(value) {
    return new Intl.NumberFormat('ar-AE', { numberingSystem: 'latn', maximumFractionDigits: 20 }).format(value);
  }

  function normalized(value) {
    return typeof value === 'string' ? value.trim().replace(/\s+/g, ' ').toLowerCase() : '';
  }

  function knownKeys(value, keys) {
    return value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).every(function (key) { return keys.indexOf(key) !== -1; });
  }

  function pointText(value, settings) {
    var labels = settings && settings.pointsLabel;
    var one = labels && typeof labels.one === 'string' ? labels.one : '';
    var many = labels && typeof labels.other === 'string' ? labels.other : '';
    var label;
    if (/^points?$/i.test(one) && /^points?$/i.test(many)) {
      label = new Intl.PluralRules('ar').select(value) === 'few' ? 'نقاط' : 'نقطة';
    } else {
      label = value === 1 ? one : many;
      if (!label) label = 'نقطة';
    }
    return format(value) + ' ' + label;
  }

  function money(value) {
    return new Intl.NumberFormat('ar-AE', { style: 'currency', currency: 'AED', numberingSystem: 'latn', minimumFractionDigits: 0, maximumFractionDigits: 20 }).format(value);
  }

  function verifiedExchange(product, settings) {
    if (currency !== 'AED' || !product || typeof product.exchangeDescription !== 'string') return null;
    var match = /^([0-9]+(?:\.[0-9]+)?)\s+(.+?)\s*=\s*(?:(AED|د\.?\s*إ)\s*([0-9]+(?:\.[0-9]+)?)|([0-9]+(?:\.[0-9]+)?)\s*(AED|د\.?\s*إ))$/i.exec(product.exchangeDescription.trim());
    if (!match) return null;
    var labels = settings && settings.pointsLabel;
    if (!labels || [normalized(labels.one), normalized(labels.other)].indexOf(normalized(match[2])) === -1) return null;
    var points = Number(match[1]);
    var value = Number(match[4] || match[5]);
    if (!number(points) || !number(value) || points !== product.variablePointsStep || value !== product.variablePointsStepRewardValue) return null;
    return { points: points, value: value };
  }

  function line(row, text, className) {
    row.appendChild(element('p', className || 'frame-smile-ar__detail', text));
  }

  function fallback(row, sourceName) {
    if (typeof sourceName === 'string' && sourceName.trim()) {
      var source = element('p', 'frame-smile-ar__source', sourceName.trim());
      source.dir = 'auto';
      row.appendChild(source);
    }
    line(row, 'تتوفر التفاصيل والشروط الكاملة لهذا الخيار في نافذة برنامج المكافآت.', 'frame-smile-ar__note');
  }

  function earningRow(rule, settings, programCurrencyVerified) {
    var row = element('li', 'frame-smile-ar__item');
    var knownName = normalized(rule && rule.name) === 'place an order';
    row.appendChild(element('h3', 'frame-smile-ar__item-title', knownName ? 'إتمام طلب' : 'طريقة لكسب النقاط'));
    var keys = ['id', 'name', 'imageUrl', 'actionText', 'actionUrl', 'restrictedToVipTierIds', 'reward', 'rewardValue', 'earningLimit'];
    if (!knownName || !knownKeys(rule, keys) || !knownKeys(rule.reward, ['type']) || rule.reward.type !== 'points' || !Array.isArray(rule.restrictedToVipTierIds) || (rule.earningLimit !== null && rule.earningLimit !== undefined)) {
      fallback(row, knownName ? '' : rule && rule.name);
      return row;
    }
    if (rule.restrictedToVipTierIds.length) {
      line(row, 'تخضع هذه الطريقة لشروط العضوية. راجع التفاصيل في نافذة المكافآت.', 'frame-smile-ar__note');
      return row;
    }
    var reward = rule.rewardValue;
    if (knownKeys(reward, ['type', 'variable']) && reward.type === 'variable' && knownKeys(reward.variable, ['value', 'perAmount']) && number(reward.variable.value) && number(reward.variable.perAmount) && reward.variable.perAmount > 0 && programCurrencyVerified) {
      line(row, 'اكسب ' + pointText(reward.variable.value, settings) + ' مقابل كل ' + money(reward.variable.perAmount) + ' تنفقه.');
    } else if (knownKeys(reward, ['type', 'fixed']) && reward.type === 'fixed' && knownKeys(reward.fixed, ['value']) && number(reward.fixed.value)) {
      line(row, 'النقاط المكتسبة: ' + pointText(reward.fixed.value, settings) + '.');
    } else {
      fallback(row, '');
    }
    return row;
  }

  function rewardRow(product, settings) {
    var row = element('li', 'frame-smile-ar__item');
    var reward = product && product.reward;
    var knownName = normalized(reward && reward.name) === 'order discount';
    row.appendChild(element('h3', 'frame-smile-ar__item-title', knownName ? 'خصم على الطلب' : 'مكافأة من البرنامج'));
    var keys = ['id', 'exchangeType', 'exchangeDescription', 'pointsPrice', 'variablePointsStep', 'variablePointsStepRewardValue', 'variablePointsMin', 'variablePointsMax', 'reward', 'createdAt', 'updatedAt'];
    var knownDescription = reward && (reward.description === null || reward.description === undefined || reward.description === '' || normalized(reward.description) === 'applies to one-time purchases.');
    if (!knownName || !knownDescription || !knownKeys(product, keys) || !knownKeys(reward, ['id', 'name', 'description', 'imageUrl', 'createdAt', 'updatedAt'])) {
      fallback(row, knownName ? '' : reward && reward.name);
      return row;
    }
    if (product.exchangeType === 'variable') {
      var exchange = verifiedExchange(product, settings);
      var minimum = product.variablePointsMin;
      var maximum = product.variablePointsMax;
      if (!exchange || exchange.points <= 0 || !number(minimum) || (maximum !== null && maximum !== undefined && (!number(maximum) || maximum < minimum))) {
        fallback(row, '');
        return row;
      }
      line(row, 'قيمة الاستبدال: ' + pointText(exchange.points, settings) + ' = ' + money(exchange.value) + ' خصمًا.');
      line(row, 'الحد الأدنى للاستبدال: ' + pointText(minimum, settings) + '.', 'frame-smile-ar__condition');
      if (number(maximum)) line(row, 'الحد الأقصى للاستبدال: ' + pointText(maximum, settings) + '.', 'frame-smile-ar__condition');
    } else if (product.exchangeType === 'fixed' && number(product.pointsPrice)) {
      line(row, 'النقاط المطلوبة للاستبدال: ' + pointText(product.pointsPrice, settings) + '.');
    } else {
      fallback(row, '');
      return row;
    }
    if (normalized(reward.description) === 'applies to one-time purchases.') line(row, 'يسري على المشتريات لمرة واحدة.', 'frame-smile-ar__condition');
    return row;
  }

  function mount() {
    var card = document.getElementById('frame-rewards-card');
    if (!card) return false;
    if (document.getElementById('frame-smile-ar-public')) return true;
    var section = element('section', 'frame-smile-ar');
    section.id = 'frame-smile-ar-public';
    section.lang = 'ar';
    section.dir = 'rtl';
    section.setAttribute('aria-label', 'معلومات برنامج المكافآت');
    var intro = element('p', 'frame-smile-ar__intro', 'اعرف كيف تكسب النقاط وما المكافآت التي يقدمها البرنامج.');
    var status = element('p', 'frame-smile-ar__status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    var retry = element('button', 'frame-smile-ar__retry', 'إعادة المحاولة');
    retry.type = 'button';
    retry.hidden = true;
    var grid = element('div', 'frame-smile-ar__groups');
    var groups = {};
    [['earningRules', 'طرق كسب النقاط'], ['pointsProducts', 'المكافآت المتاحة']].forEach(function (entry) {
      var group = element('div', 'frame-smile-ar__group');
      var heading = element('h2', 'frame-smile-ar__heading', entry[1]);
      var list = element('ul', 'frame-smile-ar__list');
      group.appendChild(heading);
      group.appendChild(list);
      grid.appendChild(group);
      groups[entry[0]] = { wrapper: group, list: list };
    });
    section.appendChild(intro);
    section.appendChild(status);
    section.appendChild(retry);
    section.appendChild(grid);
    card.insertBefore(section, card.firstChild);

    var phase = 'waiting';
    var generation = 0;
    var readyVersion = 0;
    var waitingTimer;
    var cancelWaits = new Set();

    function state(value, message) {
      phase = value;
      section.dataset.state = value;
      section.setAttribute('aria-busy', value === 'waiting' || value === 'loading' ? 'true' : 'false');
      status.textContent = message;
      retry.hidden = value !== 'error' && value !== 'partial';
      retry.disabled = value === 'loading';
    }

    function cancelPending() {
      window.clearTimeout(waitingTimer);
      cancelWaits.forEach(function (cancel) { cancel(); });
      cancelWaits.clear();
    }

    function waitForSdk() {
      state('waiting', 'جارٍ تحميل معلومات البرنامج…');
      window.clearTimeout(waitingTimer);
      waitingTimer = window.setTimeout(function () { state('error', 'تعذّر تحميل معلومات البرنامج حاليًا. يرجى إعادة المحاولة.'); }, waitMilliseconds);
    }

    function timedGet(sdk, resource) {
      return new Promise(function (resolve, reject) {
        var settled = false;
        var timer;
        function finish(error, value) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          cancelWaits.delete(cancel);
          if (error) reject(error); else resolve(value);
        }
        function cancel() { finish({ frameKind: 'canceled' }); }
        cancelWaits.add(cancel);
        timer = window.setTimeout(function () { finish({ frameKind: 'timeout' }); }, waitMilliseconds);
        Promise.resolve().then(function () { return sdk[resource].get(); }).then(function (value) { finish(null, value); }, function (error) { finish(error); });
      });
    }

    function notInitialized(result) {
      return result.status === 'rejected' && result.reason && typeof result.reason.message === 'string' && /must be initialized before calling this method/i.test(result.reason.message);
    }

    function renderGroup(resource, result, settings, verifiedCurrency) {
      var group = groups[resource];
      group.list.textContent = '';
      group.wrapper.removeAttribute('data-error-status');
      group.wrapper.removeAttribute('data-item-count');
      var valid = result.status === 'fulfilled' && Array.isArray(result.value);
      if (!valid) {
        group.wrapper.dataset.state = 'error';
        var error = result.reason;
        if (error && typeof error.status === 'number' && Number.isFinite(error.status)) group.wrapper.dataset.errorStatus = String(error.status);
        group.list.appendChild(element('li', 'frame-smile-ar__empty', 'تعذّر تحميل هذه المعلومات حاليًا.'));
        return false;
      }
      group.wrapper.dataset.itemCount = String(result.value.length);
      group.wrapper.dataset.state = result.value.length ? 'ready' : 'empty';
      if (!result.value.length) group.list.appendChild(element('li', 'frame-smile-ar__empty', resource === 'earningRules' ? 'لا توجد طرق لكسب النقاط للعرض حاليًا.' : 'لا توجد مكافآت للعرض حاليًا.'));
      result.value.forEach(function (item) { group.list.appendChild(resource === 'earningRules' ? earningRow(item, settings, verifiedCurrency) : rewardRow(item, settings)); });
      return true;
    }

    function read() {
      if (phase === 'loading') return;
      cancelPending();
      var sdk = window.Smile;
      var resources = ['earningRules', 'pointsProducts', 'pointsSettings'];
      if (!sdk || !resources.every(function (resource) { return sdk[resource] && typeof sdk[resource].get === 'function'; })) { waitForSdk(); return; }
      var current = ++generation;
      var currentReadyVersion = readyVersion;
      state('loading', 'جارٍ تحميل معلومات البرنامج…');
      Promise.allSettled(resources.map(function (resource) { return timedGet(sdk, resource); })).then(function (results) {
        if (current !== generation) return;
        if (results.some(notInitialized)) {
          waitForSdk();
          if (readyVersion !== currentReadyVersion) read();
          return;
        }
        var settingsResult = results[2];
        var settingsValue = settingsResult.status === 'fulfilled' ? settingsResult.value : null;
        var settings = settingsValue && settingsValue.pointsLabel && typeof settingsValue.pointsLabel.one === 'string' && typeof settingsValue.pointsLabel.other === 'string' && settingsValue.pointsLabel.one.trim() && settingsValue.pointsLabel.other.trim() ? settingsValue : null;
        var products = results[1].status === 'fulfilled' && Array.isArray(results[1].value) ? results[1].value : [];
        var verifiedCurrency = products.length > 0 && products.every(function (product) { return !!verifiedExchange(product, settings); });
        var earningOk = renderGroup('earningRules', results[0], settings, verifiedCurrency);
        var productsOk = renderGroup('pointsProducts', results[1], settings, verifiedCurrency);
        section.dataset.settingsState = settings ? 'ready' : 'error';
        if (earningOk && productsOk && settings) state('ready', '');
        else if (earningOk || productsOk) state('partial', 'تعذّر تحميل بعض معلومات البرنامج. يمكنك إعادة المحاولة.');
        else state('error', 'تعذّر تحميل معلومات البرنامج حاليًا. يرجى إعادة المحاولة.');
      });
    }

    retry.addEventListener('click', function () {
      generation++;
      cancelPending();
      phase = 'waiting';
      var sdk = window.Smile;
      if (!sdk || !['earningRules', 'pointsProducts', 'pointsSettings'].every(function (resource) { return sdk[resource] && typeof sdk[resource].get === 'function'; })) {
        window.location.reload();
        return;
      }
      read();
    });
    function sdkEvent() {
      readyVersion++;
      if (phase === 'waiting') read();
    }
    document.addEventListener('smile-js-loaded', sdkEvent);
    document.addEventListener('smile-js-initialized', sdkEvent);
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      generation++;
      cancelPending();
      phase = 'waiting';
      read();
    });
    read();
    return true;
  }

  function boot() {
    if (mount()) {
      if (mountObserver) mountObserver.disconnect();
      window.clearTimeout(mountTimer);
      return;
    }
    mountObserver = new MutationObserver(function () {
      if (mount()) { mountObserver.disconnect(); window.clearTimeout(mountTimer); }
    });
    mountObserver.observe(document.getElementById('MainContent') || document.querySelector('main') || document.body, { childList: true, subtree: true });
    mountTimer = window.setTimeout(function () { mountObserver.disconnect(); }, waitMilliseconds);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
